/** @format */
import { ApmBase, init } from '@elastic/apm-rum';

import { getConfig } from '@toucan/common/services/nextjs/settings';

const { publicRuntimeConfig } = getConfig();
/**
 * Here be Dragons: while this file is ostensibly written to run safely on
 * client and server side, if this file is executed at _runtime_ on server it
 * will fail because getNextConfig (used in getConfig()) is not ready, returns
 * undefined and { env } cannot be destructured.
 */
const { env } = publicRuntimeConfig;
const defaultTransactionSampleRate = 0.5;
const {
    enabled = false,
    serverUrl = '',
    transactionSampleRate = defaultTransactionSampleRate,
} = publicRuntimeConfig?.elasticApm ?? {};
const buildVersion = process.env.BUILD_VERSION;

let apm: undefined | ApmBase;

// Only let this initialise in the client
if (enabled && typeof window !== 'undefined') {
    const sampleRate = Number.isNaN(transactionSampleRate)
        ? defaultTransactionSampleRate
        : transactionSampleRate;
    console.log(
        `[INFO] Enabling Elastic APM (Release: ${buildVersion}, Environment: ${env}, Sample Rate: ${sampleRate})`
    );

    apm = init({
        // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
        serviceName: 'toucan',

        // Set custom APM Server URL (default: http://localhost:8200)
        serverUrl,

        // Set the service version (required for source map feature)
        serviceVersion: buildVersion,

        // Set the service environment
        environment: env,

        // Sets the ratio of transactions sent to elastic
        // see https://www.elastic.co/guide/en/apm/agent/rum-js/current/configuration.html#transaction-sample-rate
        transactionSampleRate: sampleRate,
    });
}

export default apm;
